//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

//local imports
import { CatalogConstants, CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";

@Component({
  selector: 'department-property',
  standalone: false,
  templateUrl: './department-property.component.html',
  styleUrl: './department-property.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentPropertyComponent {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);

  public readonly is3DViewerEnable = signal(false);
  public catalogConstants = CatalogConstants;

  public propertyResource = resource({
    request: () => ({
      id: this.route.snapshot.paramMap.get("id"),
      programId: this.route.snapshot.queryParamMap.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID),
      projectId: this.route.snapshot.queryParamMap.get(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getDepartmentProperty(
        request.id,
        request.programId,
        request.projectId,
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }
          
      return property;
    }
  });

}
